import { h, Component, Fragment } from "preact";
import { TicketHeader, TicketBody, EndedTicketPopups } from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed"

import CasinoContents from "../desktop-components/casino/casino-contents";

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as C from "../desktop-templates/cashout.jsx";
import { DesktopCasinoMultiPage } from "../desktop-components/casino/desktop";


export default function Casino({ path, type, pageCode }) {
	return <FullSite><CasinoTemplate {...{ path, type, pageCode }} /></FullSite>;
}

export function CasinoTemplate({ path, type, pageCode }) {
	type = !!type ? type : null;
	pageCode = !!pageCode ? pageCode : null;

	return <div class="font-roboto">
		<div class=" text-white w-full">
			{false && <CasinoContents />}
			<DesktopCasinoMultiPage {...{ path, type, pageCode }} />
		</div>
	</div>
}
